module.exports = __webpack_public_path__ + "img/SocialMediaPost.bc236ed7.svg";